<template>
  <div class="r-auth">
      <router-view />
  </div>
</template>

<script>
    import authStore from './auth.store';

    export default {
        mounted() {
            this.$store.registerModule('auth', authStore);
        },

        beforeDestroy() {
            this.$store.unregisterModule('auth');
        }
    };
</script>
